<template>
  <div id="compreSportsMeet_venue" v-show="currThemeObj">
    <div class="mainVenue_list">
      <span
        class="mainVenueItem"
        v-for="item in mainVenueList"
        :key="item.venueCode"
      >
        <span class="venueLogo">
          <img :src="item.venueImage" />
        </span>
        <span class="venueName" v-text="item.venueName"></span>
        <span class="venueTags_box" v-show="item.tags && item.tags.length > 0">
          <span
            class="venueTagsItem"
            v-for="ceil in item.tags"
            :key="ceil"
            v-text="ceil"
          ></span>
        </span>
        <span
          class="venueInfor"
          :class="item.tags && item.tags.length > 0 ? '' : 'addHeight'"
          v-text="item.venueDescription"
        ></span>
      </span>
    </div>
    <div class="otherVenue_list" v-if="otherList && otherList.length">
      <span class="otherVenue_title" v-text="'其他场馆'"></span>
      <span class="otherVenue_list_main">
        <span
          class="otherVenueItem"
          v-for="item in otherList"
          :key="item.venueCode"
        >
          <span class="venueName" v-text="item.venueName"></span>
          <span
            class="venueTags_box"
            v-show="item.tags && item.tags.length > 0"
          >
            <span
              class="venueTagsItem"
              v-for="ceil in item.tags"
              :key="ceil"
              v-text="ceil"
            ></span>
          </span>
          <span
            class="venueInfor"
            :class="item.tags && item.tags.length > 0 ? '' : 'addHeight'"
            v-text="item.venueDescription"
          ></span>
        </span>
      </span>
    </div>
    <NOT_DATA v-if="noData" />
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import { https_venueList } from '@api/platfrom_compreSportsMeet_api'
import NOT_DATA from '@components/base/NO_DATA.vue'
import BackTop from '@components/base/backTop.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_venue',
  components: { NOT_DATA, BackTop },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      venueTotal: null,
      mainVenueList: null,
      otherList: null,
      scrollDomById: 'containerFull_body',
      showBackTop: false,
    }
  },
  created() {
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noData() {
      return this.mainVenueList && this.venueTotal == 0
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      await this.getVenueList()

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom
      // )
      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          this.isScrollBottom = true
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    async getVenueList() {
      await https_venueList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.venueTotal = res.data.length
              this.mainVenueList = res.data.splice(0, 6)
              if (res.data && res.data.length > 0) {
                this.otherList = res.data
                this.initScroll()
              }
            } else {
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_venue {
  padding: 2.778vw 0 4.16vw 0;
  .mainVenue_list {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .mainVenueItem {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      height: 34.027vw;
      border: 1px solid var(--mixtmt_greyColor7);
      background-color: var(--mixtmt_greyColor8);
      width: calc(33.333% - 1.11vw);
      margin: 0 1.665vw 1.665vw 0;
      height: auto;
      &:nth-child(3n) {
        margin: 0 0 1.665vw 0;
      }
      .venueLogo {
        width: 100%;
        height: 15.972vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .venueName {
        padding: 0 1.041vw;
        font-size: 1.25vw;
        line-height: 3.333vw;
        height: 3.33vw;
        color: var(--mixtmt_greyColor3);
        font-weight: bold;
      }
      .venueTags_box {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        height: 2.083vw;
        padding: 0 1.041vw 0.694vw 1.041vw;
        .venueTagsItem {
          width: auto;
          padding: 0.208vw 0.694vw;
          border: 1px solid var(--mixtmt_greyColor0);
          color: var(--mixtmt_greyColor0);
          margin-right: 0.694vw;
          font-size: 0.972vw;
          line-height: 1.388vw;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .venueInfor {
        margin: 0 0.694vw;
        padding: 0.694vw 0;
        height: 12vw;
        width: calc(100% - 1.388vw);
        overflow-y: auto;
        word-break: break-word;
        font-size: 0.972vw;
        line-height: 1.38vw;
        color: var(--mixtmt_greyColor2);
        border-top: 1px solid var(--mixtmt_greyColor5);
        /* text-indent: 2em; */
        &.addHeight {
          height: calc(12vw + 2.08vw);
        }
      }
    }
  }
  .otherVenue_list {
    width: 100%;
    padding-top: 1.388vw;
    .otherVenue_title {
      width: 100%;
      padding-left: 0.694vw;
      height: 1.666vw;
      line-height: 1.666vw;
      font-size: 1.388vw;
      font-weight: bold;
      border-left: 0.347vw solid var(--mixtmt_subColor1_1);
    }
    .otherVenue_list_main {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .otherVenueItem {
        width: calc(50% - 0.694vw);
        margin: 1.388vw 1.388vw 0 0;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        height: 15.27vw;
        border: 1px solid var(--mixtmt_greyColor7);
        background-color: var(--mixtmt_greyColor8);
        &:nth-child(2n) {
          margin: 1.388vw 0 0 0;
        }
        .venueName {
          padding: 0 1.041vw;
          font-size: 1.25vw;
          line-height: 3.333vw;
          height: 3.33vw;
          color: var(--mixtmt_greyColor3);
          font-weight: bold;
        }
        .venueTags_box {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          height: 2.08vw;
          padding: 0 1.041vw 0.694vw 1.041vw;
          .venueTagsItem {
            width: auto;
            padding: 0.208vw 0.694vw;
            border: 1px solid var(--mixtmt_greyColor0);
            color: var(--mixtmt_greyColor0);
            margin-right: 0.694vw;
            font-size: 0.972vw;
            line-height: 1.388vw;
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .venueInfor {
          margin: 0 0.694vw;
          padding: 0.694vw 0;
          height: 9vw;
          width: calc(100% - 1.388vw);
          overflow-y: auto;
          font-size: 0.972vw;
          line-height: 1.38vw;
          word-break: break-word;
          color: var(--mixtmt_greyColor2);
          border-top: 1px solid var(--mixtmt_greyColor5);
          &.addHeight {
            height: calc(9vw + 2.08vw);
          }
        }
      }
    }
  }
}
</style>
